import * as React from 'react';
import { connect } from 'react-redux';
import { GlobalPrivateState } from 'src/api';
import { ConfigurationModel, WashBasinModel } from 'franke-trough-dependencies';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfo, faCheck } from '@fortawesome/free-solid-svg-icons';
import { Tooltip, Button } from 'reactstrap';
import { requestAPIActions } from 'loopback-react-request';

import { FormattedMessage } from 'react-intl';
import MESSAGES from './BasinDimensions.messages';

export interface PlateDimensionsChoiceProps {
  configuration: GlobalPrivateState['configuration'];
  dispatch: any;
  id: string;
  requiredWidth: number;
  requiredDistances: number[];
  movedDistances: number[];
  widthLimitReached: boolean;
}

export interface PlateDimensionsChoiceState {
  tooltipOpen: boolean;
  ignorableTrigger: boolean;
  selectedDecision: 'increase' | 'move' | 'cancel' | null;
}

export class PlateDimensionsChoicePartial extends React.Component<PlateDimensionsChoiceProps, PlateDimensionsChoiceState> {
  constructor(props: PlateDimensionsChoiceProps) {
    super(props);

    this.state = {
      tooltipOpen: false,
      ignorableTrigger: false,
      selectedDecision: null
    };
    this.toggle = this.toggle.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  public render() {
    const tollTipId = `plate_dimensions_required_tooltip_${this.props.id}`;

    return <>
      <span className="info-icon" id={tollTipId}>
        <FontAwesomeIcon icon={faInfo} />
        <Tooltip 
          autohide={false}
          isOpen={this.state.tooltipOpen} 
          placement="top"
          toggle={this.toggle}
          target={tollTipId}
          className="tooltip-choice"
        >
          <p>
            {!this.props.widthLimitReached ? (
              <FormattedMessage {...MESSAGES.dimensionsChoiceMessage}/>
            ) : (
              <FormattedMessage {...MESSAGES.dimensionsChoiceLimitMessage}/>
            )}
          </p>
          <>
            {!this.props.widthLimitReached && (
              <label>
                <input
                  type="radio"
                  name="decision"
                  value="increase"
                  checked={this.state.selectedDecision === 'increase'}
                  onClick={() => this.setState({ignorableTrigger: true})}
                  onChange={(ev: React.SyntheticEvent<HTMLInputElement>) => this.handleChange(ev)}
                />
                <FormattedMessage {...MESSAGES.dimensionsChoiceIncrease}/>
              </label>
            )}
            <label>
              <input
                type="radio"
                name="decision"
                value="move"
                checked={this.state.selectedDecision === 'move'}
                onClick={() => this.setState({ignorableTrigger: true})}
                onChange={(ev: React.SyntheticEvent<HTMLInputElement>) => this.handleChange(ev)}
              />
              <FormattedMessage {...MESSAGES.dimensionsChoiceMove}/>
            </label>
            <label>
              <input
                type="radio"
                name="decision"
                value="cancel"
                checked={this.state.selectedDecision === 'cancel'}
                onClick={() => this.setState({ignorableTrigger: true})}
                onChange={(ev: React.SyntheticEvent<HTMLInputElement>) => this.handleChange(ev)}
              />
              <FormattedMessage {...MESSAGES.dimensionsChoiceCancel}/>
            </label>
          </>
          <p className="text-right">
            <Button 
              onClick={(ev: React.MouseEvent<HTMLButtonElement>) => this.handleSubmit(ev, 'submit')}
              className="yes"
              disabled={this.state.selectedDecision === null}
            >
              <FontAwesomeIcon icon={faCheck} />
            </Button>
          </p>
        </Tooltip>
      </span>
    </>;
  }

  private handleChange(event: React.SyntheticEvent<HTMLInputElement>): void {
    const { value } = event.target as HTMLInputElement;

    this.setState({
      selectedDecision: value as any
    });
  }

  private get configuration(): ConfigurationModel | undefined {
    return this.props.configuration && this.props.configuration.result;
  }

  private dispatchConfiguration() {
    if (!this.configuration) { return; }
    const { washBasinDimension, apronBackSplash } = this.configuration;

    // TODO ... Use default values for PlateDimensionsHeight
    if (!washBasinDimension) { return; }

    if (apronBackSplash && washBasinDimension.distances) {
      apronBackSplash.apron = 'with';
      apronBackSplash.apronHeight = 60;
      apronBackSplash.restorablePlateDimensions = {
        plateWidth: washBasinDimension.plateWidth,
        distances: washBasinDimension.distances
      }
    }
    
    const data: WashBasinModel = washBasinDimension;

    if (this.state.selectedDecision === 'increase') {
      data.plateWidth = this.props.requiredWidth;
      data.distances = this.props.requiredDistances;
    }
    if (this.state.selectedDecision === 'move') {
      data.distances = this.props.movedDistances;
    }

    this.props.dispatch(requestAPIActions.load(
      'configuration', {
        url: `/Configurations/${this.configuration && this.configuration.id}`,
        options: {
          method: 'PATCH',
          data: {
            washBasinDimension: data,
            apronBackSplash
          }
        },
      },
      true,
    ));
  }

  private handleSubmit(event: React.MouseEvent<HTMLButtonElement>, type: 'submit') {
    if (this.state.selectedDecision !== 'cancel') {
      this.dispatchConfiguration();
    } else {
      this.setState({
        tooltipOpen: !this.state.tooltipOpen
      });
    }
  }

  private toggle() {
    if (this.state.ignorableTrigger) {
      this.setState({
        ignorableTrigger: false
      });
    } else {
      this.setState({
        tooltipOpen: !this.state.tooltipOpen
      });
    }
  }
}

export const PlateDimensionsChoice = connect((state: GlobalPrivateState) => ({
  configuration: state.configuration,
}))(PlateDimensionsChoicePartial);

export default PlateDimensionsChoice;


